import type {ToastService} from '@sms-ir/ui-components';
import {COMING_SOON_MESSAGE} from '../constants/contacts.constants';
import type {ContactEvent, ContactGroup} from '../types/contacts.types';

type ToastVariant = 'error' | 'success' | 'warning';

export function showContactsToast(
  toast: ToastService,
  variant: ToastVariant,
  message: string,
): void {
  toast.add({variant, message, icon: true, dismissible: true, duration: 4000});
}

export function notifyComingSoon(toast: ToastService): void {
  showContactsToast(toast, 'success', COMING_SOON_MESSAGE);
}

export function groupIdsFromNames(names: string[], groups: ContactGroup[]): string[] {
  return names
    .map(name => groups.find(g => g.name === name)?.id)
    .filter((id): id is string => !!id);
}

export function groupNamesFromIds(ids: string[], groups: ContactGroup[]): string[] {
  return ids
    .map(id => groups.find(g => g.id === id)?.name)
    .filter((name): name is string => !!name);
}

export function eventIdsFromNames(names: string[], events: ContactEvent[]): string[] {
  return names
    .map(name => events.find(e => e.name === name)?.id)
    .filter((id): id is string => !!id);
}

export function eventNamesFromIds(ids: string[], events: ContactEvent[]): string[] {
  return ids
    .map(id => events.find(e => e.id === id)?.name)
    .filter((name): name is string => !!name);
}

export function parseManualMobiles(raw: string): number[] {
  return raw
    .split('\n')
    .map(line => line.replace(/\s+/g, '').trim())
    .filter(Boolean)
    .map(line => Number(line))
    .filter(n => !Number.isNaN(n) && n > 0);
}

export function detectFileKind(file: File): 'text' | 'excel' {
  const name = file.name.toLowerCase();
  if (file.type === 'text/plain' || name.endsWith('.txt')) return 'text';
  return 'excel';
}

export function buildEventNameMap(events: ContactEvent[]): Map<string, string> {
  return new Map(events.map(e => [e.id, e.name]));
}
